"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var conversions = require("webidl-conversions");
var utils = require("./utils.js");
var EventInit = require("./EventInit.js");
exports._convertInherit = function (globalObject, obj, ret) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? "The provided value" : _ref$context;
  EventInit._convertInherit(globalObject, obj, ret, {
    context: context
  });
  {
    var key = "detail";
    var value = obj === undefined || obj === null ? undefined : obj[key];
    if (value !== undefined) {
      value = conversions["any"](value, {
        context: context + " has member 'detail' that",
        globals: globalObject
      });
      ret[key] = value;
    } else {
      ret[key] = null;
    }
  }
};
exports.convert = function (globalObject, obj) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? "The provided value" : _ref2$context;
  if (obj !== undefined && _typeof(obj) !== "object" && typeof obj !== "function") {
    throw new globalObject.TypeError("".concat(context, " is not an object."));
  }
  var ret = Object.create(null);
  exports._convertInherit(globalObject, obj, ret, {
    context: context
  });
  return ret;
};